<div class="sales-code-assign-modal">
  <!-- Start header -->
  <div class="sales-header flex-between-center">
    <span class="header-title flex-start-center gap-2">
      <i class="fas fa-exclamation-triangle font-14 font-900"></i>
      <span class="font-18 font-600">
        Assign Sales Code
        <span *ngIf="itemName"> - {{itemName}}</span>
      </span>
    </span>

    <span class="pointer" (click)="handleDiscardChanges()">
      <i class="fa fa-times font-18 font-300"></i>
    </span>
  </div>
  <!-- End header -->

  <!-- Start body -->
  <div class="sales-body" [ngClass]="{'flex-start': !isLoading, 'flex-center-center': isLoading}">
    <ng-container *ngIf="!isLoading">
      <div class="sale-group-wrapper width-40p flex-start" [ngClass]="{
          'width-35p height-calc-group': !isShowMultipleAssignView,
          'width-40p': isShowMultipleAssignView
        }">
        <div *ngIf="isShowMultipleAssignView" class="sales-code-unassiged width-45p flex-column">
          <ng-container *ngFor="let service of unassignedServices; let serviceIdx = index;">
            <div class="service-separator border-top" *ngIf="serviceIdx > 0"></div>

            <span class="service-title font-14 font-600 capitalize">{{service?.title || service?.titleFR}}</span>
            <div class="flex-start-center w-100 pointer" *ngFor="let item of service?.items; let itemIdx = index;"
              (click)="setNextSelectedItem(item)">
              <div class="flex-column width-90p" [ngClass]="{
                'service-item-card-secondary': skippedItems[item?.itemId]?.isSkipped,
                'service-item-card-selected': selectedItem?.itemId === item?.itemId,
                'service-item-card-error': !skippedItems[item?.itemId]?.isSkipped && selectedItem?.itemId !== item?.itemId
              }">
                <div class="flex-between-center">
                  <span class="type-badge flex-start">
                    <i class="flex-start-center" [ngClass]="iconMap[item?.type]"></i>
                    <span class="item-type">{{typeMap[item?.type]}}</span>
                  </span>
                  <i *ngIf="skippedItems[item?.itemId]?.isSkipped"
                    class="far fa-exclamation-triangle font-14 font-400"></i>
                </div>

                <span class="item-title font-14 font-600 text-truncate">{{item?.title || item?.titleFR}}</span>
              </div>
              <div *ngIf="selectedItem?.itemId === item?.itemId" class="selected-seperator"></div>
            </div>
          </ng-container>
        </div>

        <!-- sales group section -->
        <div class="h-100" [ngClass]="{
          'w-100': !isShowMultipleAssignView,
          'width-55p': isShowMultipleAssignView,
          'highlighter-border': selectedItem?.itemId
          }">
          <div class="sales-groups-list flex-column flex-start">
            <div class="sales-group-header font-14 font-600">
              Sales Groups
            </div>
            <div class="sales-group-info flex-between-center pointer" [ngClass]="{'active': saleGroup?.isActive }"
              (click)="selectSaleGroup(idx)" *ngFor="let saleGroup of salesGroupsResults; let idx = index;">
              <div class="flex-start font-14">
                <span *ngIf="saleGroup?.groupCode" class="group-code"
                  [innerHTML]="saleGroup?.groupCode | highlighter: searchQuery:'partial'"></span>
                <span *ngIf="saleGroup?.groupCode" class="group-code">&nbsp;-&nbsp;</span>
                <span class="group-code capitalize"
                  [innerHTML]="saleGroup?.name | highlighter: searchQuery:'partial'"></span>
              </div>
              <i class="fal fa-chevron-right font"></i>
            </div>

          </div>
        </div>
      </div>

      <!-- sales code section -->
      <div class="sales-code-wrapper flex-start flex-column pr-0"
        [ngClass]="{'width-65p': !isShowMultipleAssignView, 'width-60p': isShowMultipleAssignView}">
        <div class="search-sales-code w-100 pr-2">
          <app-input id="search-sales-code" type="text"
            placeholder="Search for a sales group name, sales group code, sales code name or sales code" theme="border"
            [fontSize]="14" name="search" [value]="searchQuery" [maxLength]="50" [autoFocus]="isFocusSearch"
            leftIcon="far fa-search" (appChange)="handleSearch($event)" (appBlur)="isFocusSearch = false;" (appFocus)="isFocusSearch = true;">
          </app-input>
        </div>

        <!-- Sales group details card-->
        <div class="sales-code-wrapper-body flex-column pr-2" 
          [ngClass]="{'height-calc-sale-code': !isShowMultipleAssignView}" (scroll)="onScroll($event)" id="scrollTopSection">
          <ng-container *ngFor="let saleCodeDetail of groupedSalesResults; let idx = index;">
            <div class="sales-group-detail-card flex-column" [id]="saleCodeDetail?._id">
              <a class="detail-header">
                <span class="group-title-code font-14 font-600">
                  <span class="group-code" *ngIf="saleCodeDetail?.groupCode"
                    [innerHTML]="saleCodeDetail?.groupCode | highlighter: searchQuery:'partial'"></span>
                  <span class="group-code" *ngIf="saleCodeDetail?.groupCode">&nbsp;-&nbsp;</span>
                  <span class="group-title"
                    [innerHTML]="saleCodeDetail?.salesCodeGroup | highlighter: searchQuery:'partial'"></span>
                </span>
              </a>

              <ng-container *ngFor="let saleCodeItem of saleCodeDetail?.salesCodes; let itemIndex = index;">
                <div class="sales-detail-body flex-column">
                  <div class="sales-code-detail font-14 font-400 pointer"
                    (click)="handleSelectSaleCode(saleCodeDetail, itemIndex)">
                    <ng-container *ngIf="saleCodeItem?.shortName">
                      <span class="sales-code"
                        [innerHTML]="saleCodeItem?.shortName | highlighter: searchQuery: 'partial'"></span>
                      <span class="sales-code">&nbsp;-&nbsp;</span>
                    </ng-container>

                    <span class="sales-title capitalize"
                      [innerHTML]="saleCodeItem?.title || saleCodeItem?.titleFR | highlighter: searchQuery: 'partial'"></span>
                  </div>
                </div>
              </ng-container>

              <div class="sales-detail-body flex-column flex-start-center" *ngIf="!saleCodeDetail?.salesCodes?.length">
                <span class="capitalize">No sales code exists</span>
              </div>
            </div>
          </ng-container>

          <div *ngIf="!groupedSalesResults?.length" class="flex-center-center">
            <span class="capitalize">No sales group exists</span>
          </div>
        </div>
      </div>
    </ng-container>
    <i class="fa fa-spinner rotate font-20" *ngIf="isLoading"></i>
  </div>
  <!-- End body -->

  <!-- Start footer -->
  <div *ngIf="isShowMultipleAssignView" class="sales-footer flex-end-center gap-2 border-top-lightest">
    <button class="btn btn-custom-white btn-width btn-submit" (click)="setSkippedItems(selectedItem)">Skip</button>
    <button class="btn btn-primary btn-width btn-submit" [disabled]="isSubmitting" (click)="handleSaveAndExit()">
      Save &amp; Exit
      <i class="fa fa-spinner rotate ml-1" *ngIf="isSubmitting"></i>
    </button>
  </div>
  <!-- End footer -->
</div>
